import React from 'react';
import { InventoryList } from './components/list/InventoryList';
import { InventoryDetail } from './components/detail/InventoryDetail';
import { InventoryDashboard } from './components/dashboard/InventoryDashboard';
import { TransferList } from './components/transfers/TransferList';
import { TransferDetail } from './components/transfers/TransferDetail';
import { InventoryLayout } from './components/layout/InventoryLayout';
import { LocationList } from './components/locations/LocationList';

export const inventoryRoutes = {
  path: '/inventory',
  element: <InventoryLayout />,
  children: [
    {
      index: true,
      element: <InventoryDashboard />,
    },
    {
      path: 'items',
      element: <InventoryList />,
    },
    {
      path: 'items/:id',
      element: <InventoryDetail />,
    },
    {
      path: 'locations',
      element: <LocationList />
    },
    {
      path: 'transfers',
      element: <TransferList />,
    },
    {
      path: 'transfers/:id',
      element: <TransferDetail />,
    },
  ]
}; 